<template>
    <div class="row">
        <div class="col-12">
            <table-data
                :route="prepareUrl(url.getList)"
                :settings="table.settings"
                :columns="table.columns"
                :inlineFilters="table.filters"
                :autoUpdateFilter="table.autoUpdateFilter"
                :addParamsToUrl="table.addParamsToUrl"
                :loadingMsg="table.loadingMsg"
                :notFoundMsg="table.notFoundMsg"
                :orderByTemplate="table.orderByTemplate"
                @errorLoad="showError"
            >
                <template v-slot:filters="{ tableFilters, search }">
                    <form autocomplete="false" @submit.prevent="" @keyup.enter="search">
                        <div class="row header">
                            <div class="col-12">
                                <header-list
                                    :title="pageTitle"
                                    :placeholderSearch="searchPlaceholder"
                                    v-model="tableFilters.q"
                                    :routeAddName="`${moduleCode}.${pageID}.create`"
                                    :canAdd="canAdd"
                                    :addTitle="addTitle">
                                </header-list>
                            </div>
                        </div>
                    </form>
                </template>

                <template v-slot:body="{row, columns, index, remove}">
                    <td :class="columns[0].class">
                            {{ columnValue(row, columns[0]) }}
                    </td>
                    <td :class="[columns[1].class, {'tbl-column-disabled': !row.status}]">
                        {{ columnValue(row, columns[1]) }}
                    </td>
                    <td :class="columns[2].class">
                            {{ columnValue(row, columns[2]) }}
                    </td>
                    <td :class="columns[3].class" v-html="columnStatus(row, columns[3], ['fa fa-eye','fa fa-eye-slash'])"></td>
                    <td :class="columns[4].class" v-html="columnStatus(row, columns[4])"></td>
                    <column-actions v-if="checkActions"
                        :routeEdit="`${moduleCode}.${pageID}.show`"
                        @delete="deleteItem"
                        :canDetail="canDetail"
                        :canEdit="canEdit"
                        :canDelete="canDelete"
                        :row="row"
                        :index="index"
                        :callbackDelete="remove" />
                </template>
            </table-data>
        </div>
    </div>
</template>

<script>
import GeneralMixin from '../mixins/GeneralMixin'

export default {
    name: 'DefaultLayersList',
    mixins: [
        GeneralMixin
    ],
    props: {
        panelID: {
            type: String,
            default: 'default_layers',
        },
    },
    data() {
        let pageID = this.panelID;
        return {
            pageID: pageID,
            table: {
                columns: [
                    {
                        label: `${pageID}.list.order`,
                        field: 'order',
                        sortable: true,
                        class: 'w-100px',
                    },
                    {
                        label: `${pageID}.list.name`,
                        field: 'name',
                        class: 'text-truncate',
                        sortable: true,
                    },
                    {
                        label: `${pageID}.list.behavior`,
                        field: 'behavior',
                        sortable: true,
                        func: (val) => {
                            let type = val.toLowerCase().trim();
                            return this.$t(`${this.pageID}.help.type.${type}`);
                        }
                    },
                    {
                        label: `${pageID}.list.visible`,
                        field: 'visible',
                        sortable: true,
                        class: 'w-100px text-center',
                    },
                    {
                        label: `${pageID}.list.status`,
                        field: 'status',
                        sortable: true,
                        class: 'w-100px text-center',
                    },
                    {
                        label: '',
                        field: null,
                        sortable: false,
                        class: 'actions',
                    }
                ],
            },
        }
    },
    computed: {

    },
    methods: {
    }
}
</script>